var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "VisibleView",
      class: _vm.modes.map((m) => `VisibleView--${m}`),
    },
    [
      _vm.to
        ? _c(
            "div",
            {
              staticClass: "VisibleViewButton",
              on: {
                click: function ($event) {
                  return _vm.$emit("click", $event)
                },
              },
            },
            [_c("svg-view", { attrs: { name: "visible-icon" } })],
            1
          )
        : _c(
            "div",
            {
              staticClass: "VisibleViewButton",
              on: {
                click: function ($event) {
                  return _vm.$emit("click", $event)
                },
              },
            },
            [_c("svg-view", { attrs: { name: "not-visible-icon" } })],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }